/*
 * QModel QModelViewMode enumeration
 */
export enum QModelViewMode {
  Solid = 0,
  WireFrame = 1,
}
